import {Divider, Flex, Text, Title} from "@mantine/core";

export const NoMembership = () => {

    return <Flex direction="column" gap="md">
        <Title order={5}>Du bist nicht Mitglied eines Betriebs</Title>
        <Divider />

        <Flex direction="column" gap="sm">
            <Text>
                Du kannst eine Einladung annehmen, indem du auf den Link in einer Email-Einladung klickst
            </Text>
        </Flex>
    </Flex>
}